var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"color":"blue darken-1","text":""},on:{"click":function($event){return _vm.$emit('open')}}},[_vm._v(" "+_vm._s(_vm.$t('pages.users.createFromFile'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }